module.exports = __webpack_public_path__ + "static/bg_texture2-ecfad57a0efc9bb45d9b0ed5503db27f.png";